module.exports = __webpack_public_path__ + "static/media/photo-icon1.9846440a.svg";